import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import "./dashboard.css";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { Card } from "primereact/card";
import { fetchDashboardData } from "./dashboard-store/dashboard-actions";
import CountUp from "react-countup";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dropdown } from "primereact/dropdown";
import DateRangeDropdown from "../Respondents/DateRange"; // Adjust path if needed
import { format } from "date-fns";
import DateRangeDashboard from "../Respondents/DareRangeDashbaord";
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Tooltip,
  Legend
);
const cardData = [
  {
    title: "Today’s Responses",
    valueKey: "Today_Response",
    icon: "pi pi-chart-line",
    gradientClass: "card-gradient-light-blue",
  },
  {
    title: "This Week’s Responses",
    valueKey: "Week_Response",
    icon: "pi pi-calendar",
    gradientClass: "card-gradient-light-yellow",
  },
  {
    title: "Total Responses",
    valueKey: "Total_Response",
    icon: "pi pi-chart-bar",
    gradientClass: "card-gradient-light-green",
  },
  {
    title: "Number of Questions",
    valueKey: "No_Of_Question",
    icon: "pi pi-question-circle",
    gradientClass: "card-gradient-light-purple",
  },
];
const Dashboard = () => {
  const { id: surveyId } = useParams();
  const [rows, setRows] = useState(10);
  const dispatch = useDispatch();

  const dashboardData = useSelector((state) => state.dashboard.dashboardData);
  console.log("Dashboard Data:", dashboardData);
  const totalCount = dashboardData?.data?.length || 0;
  // console.log(dashboardData)

  const rowsOptions = [
    { label: "10", value: 10 },
    { label: "50", value: 50 },
    { label: "100", value: 100 },
    { label: `All (${totalCount})`, value: totalCount },
  ];
  const [dates, setDates] = useState({
    startDate: format(
      new Date(new Date().setDate(new Date().getDate() - 7)),
      "yyyy-MM-dd"
    ),
    endDate: format(new Date(), "yyyy-MM-dd"),
  });

  useEffect(() => {
    if (surveyId) {
      dispatch(fetchDashboardData(surveyId));
    }
    
  }, [dispatch, surveyId]);

useEffect(() => {
  if (dashboardData?.chart?.length) {
    const surveyStartDate = new Date(dashboardData.chart[0].DateValue);
    const surveyEndDate = new Date(
      dashboardData.chart[dashboardData.chart.length - 1].DateValue
    );

    const calculatedStartDate = new Date(surveyEndDate);
    calculatedStartDate.setDate(calculatedStartDate.getDate() - 7);

    const adjustedStartDate =
      calculatedStartDate < surveyStartDate
        ? surveyStartDate
        : calculatedStartDate;

    setDates({
      startDate: format(adjustedStartDate, "yyyy-MM-dd"),
      endDate: format(surveyEndDate, "yyyy-MM-dd"),
    });
  }
}, [dashboardData]);

  const filteredChart =
    dashboardData?.chart?.filter((item) => {
      const date = new Date(item.DateValue);
      return (
        date >= new Date(dates.startDate) && date <= new Date(dates.endDate)
      );
    }) || [];

  const chartLabels =
    filteredChart.map((item) =>
      new Date(item.DateValue).toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
      })
    ) || [];

  const chartValues = filteredChart.map((item) => item.no_of_response) || [];

  const chartData = {
    labels: chartLabels,
    datasets: [
      {
        label: "Responses",
        data: chartValues,
        backgroundColor: chartValues.map(
          (_, i) => `hsl(${(i * 25) % 360}, 70%, 55%)`
        ),
        borderRadius: 8,
        borderWidth: 1,
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: {
        backgroundColor: "#1e293b",
        titleColor: "#fff",
        bodyColor: "#fff",
        borderColor: "#38bdf8",
        borderWidth: 1,
        cornerRadius: 6,
      },
    },
    animation: {
      duration: 2500, // slower build-in
      easing: "easeOutQuart", // smooth ease
    },
    scales: {
      x: {
        grid: { display: false },
        ticks: { padding: 5, color: "#475569", font: { weight: "bold" } },
      },
      y: {
        beginAtZero: true,
        ticks: {
          stepSize: 20,
          padding: 6,
          color: "#475569",
          font: { weight: "bold" },
        },
        grid: {
          color: "rgba(203, 213, 225, 0.3)",
          borderDash: [4, 4],
        },
      },
    },
    datasets: {
      bar: {
        barThickness: 25,
        maxBarThickness: 30,
      },
    },
  };

  return (

    <div className="container my-2">
       <div className="col-md-6 mb-2 col-12 fw-bold">
          <span> { dashboardData?.Survey_Code } |  {dashboardData?.Survey_Name}</span>
        </div>
      {/* Summary Cards */}
      <div className="d-flex gap-4 flex-wrap" style={{ marginBottom: "2rem" }}>
        {cardData.map((card, i) => (
          <div
            key={i}
            style={{
              flex: "1",
              minWidth: "250px",
              animationDelay: `${i * 0.2}s`,
            }}
            className={`summary-card ${card.gradientClass} card-animate`}
          >
            <div className="card-header d-flex justify-content-between align-items-center">
              <div className="card-text">
                <CountUp
                  start={0}
                  end={Number(dashboardData?.[card.valueKey] || 0)}
                  duration={3}
                  separator=","
                  className="countup-number"
                />
                <h3 className="mb-1">{card.title}</h3>
              </div>

              {/* Animated icon pulse */}
              <div className="card-icon icon-pulse">
                <i
                  className={`${card.icon}`}
                  style={{ fontSize: "2.5rem" }}
                ></i>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Chart */}
      <div className="row mt-4" style={{ marginBottom: "0.7rem" }}>
        <div className="col-12 chart-container">
          <Card
            title={
              <div
                className="d-flex flex-wrap justify-content-between align-items-center"
                style={{ gap: "1rem" }}
              >
                <span
                  style={{
                    fontWeight: 600,
                    fontSize: "1.1rem",
                    flex: "1 1 auto",
                    minWidth: 0,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  Responses Over Time
                </span>
                <div
                  style={{
                    minWidth: "220px",
                    maxWidth: "260px",
                    width: "100%",
                  }}
                >
                  <DateRangeDashboard
                    initialDates={{
                      startDate: new Date(dates.startDate),
                      endDate: new Date(dates.endDate),
                    }}
       surveyStartDate={
  dashboardData?.chart?.length
    ? new Date(dashboardData.chart[0].DateValue)
    : new Date()
}
surveyEndDate={
  dashboardData?.chart?.length
    ? new Date(
        dashboardData.chart[dashboardData.chart.length - 1].DateValue
      )
    : new Date()
}

                    onChange={(newDates) =>
                      setDates({
                        startDate: format(newDates.startDate, "yyyy-MM-dd"),
                        endDate: format(newDates.endDate, "yyyy-MM-dd"),
                      })
                    }
                  />
                </div>
              </div>
            }
          >
            <Bar data={chartData} options={chartOptions} />
          </Card>
        </div>
      </div>

      {/* Question Breakdown */}
      <div className="row">
        <div className="col-12">
          <Card title="Question Breakdown">
            <DataTable
              value={dashboardData?.data || []}
              paginator
              rows={rows}
              onPage={(e) => setRows(e.rows)}
              rowsPerPageOptions={rowsOptions.map((opt) => opt.value)} // Values for paginator
              paginatorTemplate={{
                layout:
                  "PrevPageLink PageLinks NextPageLink RowsPerPageDropdown",
                RowsPerPageDropdown: (options) => (
                  <Dropdown
                    value={options.value}
                    options={rowsOptions}
                    onChange={(e) => options.onChange(e)}
                  />
                ),
              }}
              scrollable
              style={{ width: "100%" }}
              emptyMessage="It looks like there are no questions yet."
            >
              <Column
                field="question_code"
                header="Code"
                sortable
                style={{ maxWidth: "20%" }}
              />
              <Column
                field="question_description"
                header="Description"
                sortable
                style={{ maxWidth: "60%" }}
              />
              <Column
                field="number_of_response"
                header="Responses"
                sortable
                style={{ maxWidth: "20%", textAlign: "center" }}
              />
            </DataTable>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
